import LetterAvatar from "@/components/Avatar/LetterAvatar"
import StatusBadge from "@/components/ui/badge"
import { Button } from "@mui/material"
import { format } from "date-fns" // For formatting dates

export const columns = (onViewDetails) => [
  {
    header: "Name",
    accessorKey: "log_name",
    cell: ({ row }) => <LetterAvatar name={row.original.log_name} />,
  },
  {
    header: "Description",
    accessorKey: "description",
    cell: ({ row }) => (
      <span title={row.original.description}>
        {row.original.description?.length > 50
          ? `${row.original.description.substring(0, 50)}...`
          : row.original.description}
      </span>
    ),
  },
  {
    header: "Causer",
    cell: ({ row }) =>
      row.original.causer?.name ? (
        <LetterAvatar
          name={row.original.causer.name}
          subtitle={row.original?.causer?.email}
        />
      ) : (
        "System"
      ),
  },
  {
    header: "Event",
    accessorKey: "event",
    cell: ({ row }) => <StatusBadge name={row.original.event} />,
  },
  {
    header: "Date",
    accessorKey: "created_at",
    cell: ({ row }) =>
      row.original.created_at
        ? format(new Date(row.original.created_at), "dd MMM yyyy, HH:mm")
        : "N/A",
  },
  {
    header: "Actions",
    cell: ({ row }) => (
      <Button
        variant="outlined"
        size="small"
        onClick={() => onViewDetails(row.original)}
      >
        View
      </Button>
    ),
  },
]
